
<template>
  <div v-wechat-title="titleTop">
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="whiteback">
      <form action="/">
        <van-search v-model="search.key" readonly show-action placeholder="请输入搜索关键词" @click="onSearch" @cancel="onCancel" />
      </form>
      <van-dropdown-menu>
        <van-dropdown-item v-model="search.sort" :options="optionSort" @change="selectTypeClose" />
        <van-dropdown-item v-model="search.tag" :options="optionTag" @change="selectTypeClose" />
      </van-dropdown-menu>
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.commodityId" class="commodity" @click="onCommodity(item.commodityId)">
          <van-row>
            <van-col span="1">
              <van-image
                width="8em"
                height="8em"
                :src="item.icon?item.icon+'?x-oss-process=style/commodityicon':'/img/defaultcom.jpg'"
              />
            </van-col>
            <van-col span="23">
              <div class="infoRect">
                <div class="title"> {{ item.name }}</div>
                <div v-if="item.tags" class="tag">
                  <van-tag v-for="tag in item.tags.split('/')" :key="tag" color="#dadada" text-color="#333">{{ tag }}</van-tag>
                </div>
                <div class="priceLine">
                  <div class="price" :style="'color: '+GetColorMain()">￥<span>{{ parseInt(item.price) }}</span>.{{ ("0"+parseInt((100*item.price+0.5-100*parseInt(item.price)))).slice(-2) }}</div>
                  <div class="totalNum">{{ item.num }}+条关注 {{ Math.round(item.favorableRate) }}%好评</div>
                  <!-- 年销{{ item.SellNum }}+
                    <span v-if="item.favorableRate>0"> {{ Math.round(item.favorableRate) }}%好评</span>
                    <span v-if="item.favorableRate<=0 && item.favorableRate>0"> 关注{{ item.favorableRate }}+</span> -->
                </div>
                <div v-if="item.activityTags" class="tag">
                  <van-tag v-for="activity in item.activityTags.split('/')" :key="activity" round plain type="success">{{ activity }}</van-tag>
                  <!-- <van-tag round plain type="success">新品</van-tag>
                  <van-tag round plain type="danger">会员满1000减100</van-tag> -->
                </div>
              </div>
            </van-col>
          </van-row>

        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import request from '@/utils/request'
import { Button, Search, DropdownMenu, DropdownItem, List, Image, Tag } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'

export default {
  components: {
    [Button.name]: Button,
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    [Image.name]: Image,
    [Tag.name]: Tag,
    TopBar
  },
  data() {
    return {
      titleTop: GetSysTitle(),
      title: '商品清单',
      backurl: '/store/index',
      search: {
        typeId: undefined,
        sort: 'BASE',
        tag: undefined,
        key: undefined,
        limit: 30,
        page: 1,
        groupKey: undefined
      },
      loading: undefined,
      finished: false,
      list: [],
      optionSort: [
        { text: '推荐排序', value: 'BASE' },
        { text: '价格最低', value: 'LOW' },
        { text: '价格最高', value: 'HIGH' },
        { text: '销量最高', value: 'SELL' },
        { text: '好评最多', value: 'COMMENT' }
      ],
      optionTag: [
        { text: '标签', value: undefined },
        { text: '入门', value: '入门' },
        { text: '高性价比', value: '高性价比' }
      ]
    }
  },
  activated() {
    var type = getUrlKey('type')
    var key = getUrlKey('key')
    this.search.groupKey = getUrlKey('groupKey')
    console.log('访问list页面activated', type)
    if (type !== this.search.typeId || key !== this.search.key) {
      this.init()
    }
    this.search.typeId = type
    this.search.key = key
  },
  created() {
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onSearch() {
      this.$router.push('/store/search')
    },
    onCancel() {
      this.search.key = undefined
      this.init()
    },
    selectTypeClose() {
      this.init()
    },
    init() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onLoad() {
      if (this.loading === undefined) {
        this.loading = true
        return
      }
      this.loading = true
      request({
        url: '/Store/getShopCommodityList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    },
    onCommodity(id) {
      this.$router.push('/store/item/' + id)
    }
  }
}
</script>
<style scoped>
.commodity{
  position: relative;
  color: #000;
  border-bottom: 1px solid #f3f3f3;
  padding: 0.5em;
}
.commodity .infoRect{
  left: 8em;
  width: calc(100% - 7.5em);
  margin-left: 7.5em;
  color:#333;
}
.commodity .infoRect .title{
  overflow: hidden;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.commodity .tag span{
  padding: 0.3em 0.5em;
  line-height: 1em;
  margin: 0.3em 0.6em 0.3em 0;
}
.commodity .priceLine{
  position: relative;
  height: 2em;
}
.commodity .priceLine .price{
  color: #f00;
  float: left;

}
.commodity .priceLine .price span
{
  font-size: 1.4em;
}
.commodity .priceLine .totalNum{
  float: left;
  font-size:0.8em;
  color: #999;
  padding: 0.7em 0 0 0.5em;
}
</style>
